import { render, staticRenderFns } from "./HistoricoCandidaturas.vue?vue&type=template&id=43ca3f40&"
import script from "./HistoricoCandidaturas.vue?vue&type=script&lang=js&"
export * from "./HistoricoCandidaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports